import React from 'react';

import {alertActions} from '../../user-manager';
import {ElementForm, Input} from '../../form-component';
import {HistoryManager} from '../../history-manager';
import {ModelManager} from "../../model-manager";
import {SessionManager} from "../../session-manager";
import {connect} from 'react-redux';
import {Link} from "react-router-dom";

class GetNewPasswordForm extends ElementForm {
    constructor(props) {
        const element = {
            '@id': '/api/request_password_histories',
            email: '',
        };

        super(props, element);
    }

    submit(e) {
        e.preventDefault();
        const {dispatch} = this.props;

        let violations = [];

        if (this.state.element.email === '') {
            violations.push({propertyPath: 'email', message: 'L\'email est obligatoire.'});
        }

        if (violations.length === 0) {
            ModelManager.save(this.state.element).then((element) => {
                if (!SessionManager.isAuthenticated()) {
                    HistoryManager.getHistory().push('/login');
                }
                dispatch(alertActions.success('Si votre compte existe un email sera envoyé.'));
            }).catch(error => {
                error.violations ? this.mapErrors(error.violations) : this.cleanErrors();
            });
        } else {
            this.mapErrors(violations);
        }
    }

    render() {
        return (
            <form className="form-horizontal" noValidate>
                <div className="form-group">
                    <div className="col-md-12">
                        <Input name="email" label="Email" type="email"
                            value={this.state.element.email}
                            errors={this.state.errors.email} updateElement={this.updateElement}
                            required={true}/>
                    </div>
                </div>
                <div className="form-group push-up-20">
                    <div className="col-md-6">
                        <Link to="/login" className="btn btn-link btn-block">Se connecter</Link>
                    </div>
                    <div className="col-md-6">
                        <button onClick={this.submit} className="btn btn-danger btn-block">Réinitialiser</button>
                    </div>
                </div>
            </form>
        );
    }
}
function mapStateToProps(state) {
    return {};
}

const ConnectedGetNewPasswordForm = connect(mapStateToProps)(GetNewPasswordForm);
export {ConnectedGetNewPasswordForm as GetNewPasswordForm};